/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    CANCEL: 'Abbrechen',
    CONFIRM: 'Bestätigen',
    NEW_INVOICE: 'Neue Rechnung'
  },
  ERROR: {
    ACCUMULATE_SUBMITTED: 'Fehler beim Senden der Ansammlung',
    CANCEL_ACCUMULATION: 'Fehler beim Abbrechen der Ansammlung',
    CANCEL_INVOICE: 'Fehler beim Stornieren der Rechnung',
    COUPON_CANCELED: 'Fehler beim Stornieren des Gutscheins',
    COUPON_GENERATED: 'Fehler beim Erstellen des Gutscheins',
    ERROR: 'Fehler',
    INVOICE_SUBMITTED: 'Fehler beim Senden der Rechnung'
  },
  HEADER: {
    ACCU_REMUNERATION: 'Angesam. Vergütung',
    ATTACHMENT: 'Anhang',
    CHALLENGE: 'Challenge',
    COUPON: 'Gutschein',
    COUPON_CODE: 'Gutscheincode',
    DECISION: 'Entscheidung',
    MONTH: 'Monat',
    OBSERVATIONS: 'Beobachtungen',
    REMUNERATION: 'Vergütung',
    STATE: 'Status',
    SUBMISSION_DATE: 'Sendedatum'
  },
  LABEL: {
    ACCUMULATE: 'Ansammeln',
    ACCUMULATED: 'Angesammelt',
    ACTIVES: 'Aktive',
    ALL: 'Alle',
    BEGIN_DATE: 'Startdatum',
    CANCEL: 'Abbrechen',
    CANCEL_ACCUMULATION: 'Ansammlung abbrechen',
    CANCEL_COUPON: 'Gutschein abbrechen',
    CANCEL_INVOICE: 'Rechnung abbrechen',
    CLOSE: 'Schließen',
    CODE: 'Code',
    CONFIRM: 'Bestätigen',
    CONFIRM_ACCUMULATE: 'Ansammeln',
    CONFIRM_COUPON_CREATION: 'Gutschein generieren',
    CONFIRM_SUBMIT_INVOICE: 'Senden',
    COPY_COUPON_CODE: 'Gutscheincode kopieren',
    COUPON: 'Gutschein',
    COUPON_CODE: 'Gutscheincode',
    CURRENT_PERIOD: 'Aktueller Zeitraum',
    DATE: 'Datum',
    DESCRIPTION: 'Beschreibung',
    END_DATE: 'Enddatum',
    FILTER: 'Filter',
    GENERATE_COUPON: 'Gutschein generieren',
    GO_TO_DETAILS: 'Einzelheiten',
    INVOICE: 'Rechnung',
    MODEL: 'Modell',
    MONEY: 'Geld',
    MONTH: 'Monat',
    NEW_INVOICE: 'Neue Rechnung',
    PAYMENT_METHOD: 'Zahlungsmethode',
    PENDING_COUNTERPARTS: 'Ausstehende Gegenleistungen',
    PENDING_COUNTERPARTS_MODAL_TITLE: 'Ausstehende Gegenleistungen',
    PENDING_VALUE: 'Ausstehender Wert',
    PREVIOUS_PERIOD: 'Vorheriger Zeitraum',
    REMUNERATION: 'Vergütung',
    SELECTED_PRODUCTS: 'Ausgewählte Produkte',
    STATE: 'Status',
    SUBMIT_INVOICE_ATTACHMENT: 'Anhang (PDF)',
    SUBMIT_INVOICE_COMMENT: 'Kommentar',
    SUBMIT_MANUAL_REMUNERATION_INVOICE_VALUE: 'Wert',
    WITHOUT_PRODUCTS: 'Ohne ausgewählte Produkte',
    YEAR: 'Jahr'
  },
  SENTENCE: {
    CANCEL_ACCUMULATION: 'Möchtest du das Ansammeln wirklich abbrechen?',
    CANCEL_COUPON: 'Möchtest du den {value}-Gutschein wirklich abbrechen?',
    CANCEL_INVOICE: 'Möchtest du das Senden der Rechnung wirklich abbrechen?',
    CANT_GENERATE_COUPON: 'Du kannst diesen Gutschein nicht generieren.',
    CANT_SUBMIT_REMUNERATION: 'Du kannst diese Rechnung nicht senden.',
    CONFIRM_SUBMIT_COUPON:
      'Du generierst einen Gutschein im Wert von {couponValue}. Möchtest du fortfahren?',
    EMPTY_TITLE: 'Kein Daten'
  },
  SUCCESS: {
    ACCUMULATE_SUBMITTED: 'Angesammelte Vergütung',
    CANCEL_ACCUMULATION: 'Ansammlung abgebrochen',
    CANCEL_INVOICE: 'Rechnung storniert',
    COUPON_CANCELED: 'Gutschein abgebrochen',
    COUPON_COPIED: 'Gutschein in die Zwischenablage kopiert',
    COUPON_GENERATED: 'Gutschein mit %{value}-Code erstellt',
    INVOICE_SUBMITTED: 'Rechnung eingereicht',
    SUCCESS: 'Erfolg'
  },
  TOOLTIP: {
    ACCU_REMUNERATION: 'Angesammelte Vergütung',
    ATTACHMENT: 'Anhang',
    CHALLENGE: 'Challenge',
    COUPON: 'Gutschein',
    COUPON_CODE: 'Gutscheincode',
    DECISION: 'Entscheidung',
    MONTH: 'Monat',
    OBSERVATIONS: 'Beobachtungen',
    REMUNERATION: 'Vergütung',
    STATE: 'Status',
    SUBMISSION_DATE: 'Sendedatum',
    SWIPE: 'Nach links wischen, um weitere Spalten anzuzeigen.',
    VIEW_CHALLENGE_DETAILS: 'Details zur Challenge anzeigen'
  }
};
